<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <b-modal v-model="isRejectedModal"
             :no-close-on-backdrop="true"
             centered title="Rejection reason"
             @cancel="closeDeleteModal"
             @ok="removeItem">
      <form>
        <TextBox v-model="reason" placeholder="Reason">Reason</TextBox>
      </form>
    </b-modal>
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="3">
                      <div class="form-group">
                        <label>Photo</label>
                        <div class="d-flex justify-content-center p-4">
                          <div class="profile-img-upload">
                            <img v-if="this.item.image.url" :src="this.item.image.url" alt="img">
                            <img v-else src="../../assets/img/image.jpg" alt="img">
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label>Task</label>
                        <div class="summary-field">{{ item.task ? item.task.title : '' }}</div>
                      </b-form-group>
                      <b-form-group>
                        <label>Member</label>
                        <div class="summary-field">{{ item.member ? memberName(item.member) : '' }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label>Coin</label>
                        <div class="summary-field">{{ item.totalCoin ? item.totalCoin : '' }}</div>
                      </b-form-group>
                      <b-form-group>
                        <label>Status</label>
                        <div class="summary-field">{{ item.status === 'COMPLETED' ? 'Completed' : item.status === 'REJECTED' ? 'Rejected' : item.status === 'WAITING' ? 'Waiting' : item.status }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label>Date</label>
                        <div class="summary-field">{{ dateFormat(item.date) }}</div>
                      </b-form-group>
                      <b-form-group v-if="this.item.status === 'REJECTED'">
                        <label>Reason</label>
                        <div class="summary-field">{{ item.reason ? item.reason : '' }}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                    <div class="d-flex justify-content-end">
                      <div class="form-actions">
                        <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/approve-task'">Cancel</router-link>
                        <b-button v-if="this.item.status === 'WAITING'" right type="submit" variant="danger" @click="showModal()">Reject</b-button>
                        <b-button v-if="this.item.status === 'WAITING'" right type="submit" variant="primary" @click="onSubmit()">Approve</b-button>
                      </div>
                    </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ApproveTaskAddEditPage',
  data () {
    return {
      item: {},
      reason: '',
      isRejectedModal: false
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      return
    }
    this.$loading.show()
    this.axios.get('daily-task-member/item', {params: {id: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  computed: {
    pageName () {
      return 'Approve Task'
    }
  },
  methods: {
    onSubmit () {
      this.item.status = 'COMPLETED'
      this.$loading.show()
      let axios = this.axios.post('daily-task-member/review-task-process', this.item)
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/approve-task')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    },
    dateFormat (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm') : ''
    },
    memberName (member) {
      let fullName = ''
      if (member.firstName) {
        fullName += member.firstName
      }
      if (member.lastName) {
        fullName += ' ' + member.lastName
      }
      return fullName
    },
    closeDeleteModal () {
      this.$nextTick(() => {
        this.reason = ''
        this.isRejectedModal = false
      })
    },
    showModal () {
      this.isRejectedModal = true
    },
    removeItem () {
      this.item.status = 'REJECTED'
      this.item.reason = this.reason
      this.$loading.show()
      let axios = this.axios.post('daily-task-member/review-task-process', this.item)
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/approve-task')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/approveTask/ApproveTaskAddEditPage.vue